export const environment = {
  production: false,
  ForceApiKey: "ulOiHF#ISNndbza6F55KBQU!Kk35vzMe4QYYMAiIPVL&am+Zzxy6$Ne57wNK6nVBhNiT2ld-JE7f5F8zfrgfKw172J*4iD+fh7VPGtM1NoG*DQC%H=yiGobTBp;9v$vO14SK",
  encryptSecretKey: "407708e72dc5113cb7e442f697033f69637510553aeb1db49eda6e8b48085930",
  //BASE_URL: 'https://clpmsapi.hrrl.spikyarc.net/API/',
  //BASE_URL_LOGIN: 'https://clpmsapi.hrrl.spikyarc.net/',
  //PHOTO_URL: 'https://clpmsapi.hrrl.spikyarc.net/API/Documents/Photos/LabourPhotos/',
  //DOC_URL: 'https://clpmsapi.hrrl.spikyarc.net/API/Documents/TaskDocuments/',
};

